import { store } from '../store/store.js';

export default class InitMap{

	constructor(){
		if($('#campus-map').length){
			this.cache = {
				$mapContainer: $('.map__categories'),
				$dropdown: $('.map__categories').find('.dropdown'),
				$mapSearch: $('.map__container .map__search'),
				$mapSearchInput: $('.map__container .map__menu').find('input[type=search]'),
				$dropdownList: $('.map__categories').find('.dropdown ul'),
				$dropdownItem: $('.map__categories').find('.dropdown ul li'),
				$dropdownItemAll: $('.map__categories').find('.dropdown ul li[data-code="all"]'),
				$dropdownActiveItems: $('.map__categories').find('.dropdown ul li.is-active'),
				$dropdownCheck: $('.map__categories').find('.dropdown ul li input[type=checkbox]'),
				$dropdownItemName: $('.map__categories').find('.dropdown ul li').data('name'),
				$mapInfo: $('.map__container').find('.map__info'),
				// The location of Macquarie University
				mq: { lat: -33.77364531605791, lng: 151.112639069443 },
				// The bounds of all markers
				bounds: new google.maps.LatLngBounds(),
				icon: {
					path: "M19.9,8.59c0.37,2.69-0.33,5.2-1.74,7.18c-1.9,2.67-3.74,5.38-5.21,8.32l-2.06,4.13,c-0.37,0.74-1.42,0.74-1.79,0l-2.24-4.49c-1.39-2.79-3.15-5.36-4.98-7.88C0.7,14.2,0,12.18,0,10C0,4.08,5.14-0.64,11.2,0.07,C15.65,0.59,19.3,4.15,19.9,8.59z",
					// path: "M10.71,36.82L1.33,18.07C-2.82,9.77,3.22,0,12.5,0h0c9.28,0,15.32,9.77,11.17,18.07l-9.38,18.75,C13.55,38.3,11.45,38.3,10.71,36.82z M12.5,8.17c-2.76,0-5,2.24-5,5s2.24,5,5,5s5-2.24,5-5S15.26,8.17,12.5,8.17z",
					fillColor: '#A6192E',
					fillOpacity: 1,
					strokeWeight: 0,
					scale: 1,
					labelOrigin: new google.maps.Point(10, 50),
				},
				iconFocus: {
					path: "M23.87,10.3c0.44,3.22-0.4,6.24-2.08,8.61c-2.28,3.21-4.49,6.45-6.25,9.97l-2.47,4.95\
						c-0.44,0.88-1.7,0.88-2.15,0l-2.69-5.39c-1.67-3.34-3.78-6.42-5.97-9.45C0.84,17.02,0,14.61,0,11.99C0,4.9,6.17-0.76,13.43,0.08\
						C18.77,0.71,23.14,4.97,23.87,10.3z",
					// path: "M10.71,36.82L1.33,18.07C-2.82,9.77,3.22,0,12.5,0h0c9.28,0,15.32,9.77,11.17,18.07l-9.38,18.75,C13.55,38.3,11.45,38.3,10.71,36.82z M12.5,8.17c-2.76,0-5,2.24-5,5s2.24,5,5,5s5-2.24,5-5S15.26,8.17,12.5,8.17z",
					fillColor: '#A6192E',
					scaledSize: new google.maps.Size(50,50),
					fillOpacity: 1,
					strokeWeight: 0,
					scale: 1,
					labelOrigin: new google.maps.Point(10, 50),
				},
			}

			this.initMap()
		}
	}

  initMap(){
		let _this = this
		// Array of location objects
		let locations = window.locations
    // The map, centered at on Macquarie University
    const map = new google.maps.Map(document.getElementById("campus-map"), {
      zoom: 15,
			minZoom: 15,
      center: this.cache.mq,
			gestureHandling: "cooperative",
			mapTypeControl: false,
			disableDefaultUI: true,
			styles: [
				{
					featureType: "poi.business",
					stylers: [{ visibility: "off" }],
				},
				{
					featureType: "transit",
					elementType: "labels.icon",
					stylers: [{ visibility: "off" }],
				},
				{
					featureType: "poi.medical",
					elementType: "labels.icon",
					stylers: [{ visibility: "off" }],
				},
				{
					featureType: "poi.school",
					elementType: "labels.icon",
					stylers: [{ visibility: "off" }],
				},
				{
					featureType: "poi.government",
					elementType: "labels.icon",
					stylers: [{ visibility: "off" }],
				},
				{
					featureType: "poi.medical",
					elementType: "labels.icon",
					stylers: [{ visibility: "off" }],
				},
				{
					featureType: "poi.sports_complex",
					elementType: "labels.icon",
					stylers: [{ visibility: "off" }],
				},
    	],
    })
		// Map clusterer options
		const clusterOptions = {
			ignoreHidden: true,
			styles:[{
				url: "",
				width: 25,
				height: 25,
				textSize: 16,
				fontWeight: 600,
				textColor: "white",
			}]
		}

		// Markers object
		let markers = this.initMarkers(map, locations)
		// Creates Clusterer
		const markerCluster = new MarkerClusterer(map, markers, clusterOptions)

		// Map secondary functionality
		if($('.map__container').hasClass('map--secondary')){
			$.each(markers, function(i, marker){
				let label = {
					text: marker.name,
					color: '#373A36',
					fontFamily: "Work Sans",
					fontWeight: '500',
					className: 'marker'
				}
				marker.setVisible(true)
				marker.addListener("click", () => {
					_this.focusLocation(map, marker, markers)
					_this.showListing(marker)
				})
				marker.setLabel(label)
			})
		}

		// If regular map
		if(!$('.map__container').hasClass('map--secondary')){
			this.setDefaultMarkers(map, markers)
			this.setListeners(map, locations, markers, markerCluster)
			this.initListings(locations)
		}
  }

	// Create markers
	initMarkers(map, locations){
		let _this = this
		const markers = locations.map((location, i) => {

			return new google.maps.Marker({
				code: location.code,
				name: location.name,
				lat: location.lat,
				lng: location.lng,
				position: new google.maps.LatLng(location.lat, location.lng),
				map: map,
				primarytype: location.primarytype,
				secondarytype: location.secondarytype,
				information: location.information,
				img: location.img,
				link: location.link,
				linktext: location.linktext,
				width: 25,
				icon: _this.cache.icon,
				iconFocus: _this.cache.iconFocus,
				anchorPoint: new google.maps.Point(0, 0),
				visible: false,
			})
		})
		return markers
	}

	// Fill search list with location objects
	initListings(locations){
		var noResults = 'Sorry, nothing matched your search'
		$('.map__search--input').append('<ul data-type="listings">'+locations.map((location, i) => {
			var img = ''
			var information = ''
			var link = ''
			if(location.img.length != 0){
				img += '<img src=' + location.img + ' alt=' + location.name + '>'
			}
			if(location.information.length != 0){
				information += '<p class="margin-btm--8">' + location.information + '</p>'
			}
			if(location.link.length != 0 && location.linktext.length != 0){
				link += '<a target="_blank" href='+location.link+' class="link--cta">' + location.linktext + '</a>'
			}
			return '<li data-type='+location.primarytype+' data-code='+location.code+' data-tag='+location.secondarytype+'>\
								<div>\
				    			<span>'+ location.name +'</span>\
									'+information+'\
									'+link+'\
									<a target="_blank" href="https://www.google.com/maps?saddr=My+Location&daddr='+location.lat+','+location.lng+'" class="link--cta">Get directions</a>\
								</div>\
								'+img+'\
			 				</li>'
		}).join('') + '<li class="no-results">' + noResults + '</li></ul>')
		// Appends an empty element for spacing on mobile
		$('.map__search--input ul').append('<span class="pad-left-wrap--16"></span>')
	}

	// Set listeners
	setListeners(map, locations, markers, markerCluster){
		let _this = this
		// Show all markers related to selected category and transition menu to listings
		$('.map__categories').find('button').on('click', function(){
			let $currentItem = $(this)
			let $currentType = $currentItem.data('type')
			// Adds selected category as search input value
			$('.map__search').find('input[type=search]').val($(this).data('type').charAt(0).toUpperCase() + $(this).data('type').slice(1).replace(/\-/g, ' ')).trigger('change')
			$(this).closest('.map__categories').removeClass('is-active')
			$('#campus-map').removeClass('is-hidden')
			_this.toggleMarkers($currentItem, $currentType, map, locations, markers, markerCluster)
			_this.scrollToTop()
		})

		// Activates search overlay on mobile
		$('.map__search--input').find('input[type=search]').on('click', function(){
			$(this).closest('.map__search--input').find('.map__categories').addClass('is-active')
			$('#campus-map').addClass('is-hidden')
			_this.scrollToTop()
		})



		// Reset menu to default state when back button is selected
		// $('.map__search').find('button[data-type="previous"]').on('click', function(){
		// 	_this.resetMenu(map, markers, markerCluster)
		// 	let $self = $(this).closest('.map__search').find('input[type=search]')
		// 	_this.toggleIcons($self)
		// })

		// Clears value inside input
		$('.map__search').find('button[name="clear"]').on('click', function(){
			_this.resetMenu(map, markers, markerCluster)
			$('#campus-map').removeClass('is-hidden')
			$(this).closest('.map__search').find('input[type=search]').val('')
			let $self = $(this).closest('.map__search').find('input[type=search]')
			_this.toggleIcons($self)
		})

		// When marker is selected, single in on specific marker location
		$.each(markers, function(i, marker){
			let label = {
				text: marker.name,
				color: '#373A36',
				fontFamily: "Work Sans",
				fontWeight: '500',
				className: 'marker'
			}
			marker.addListener("click", () => {
				_this.focusLocation(map, marker, markers)
				_this.scrollToListing(marker)
				if($('.map__container').hasClass('map--secondary')){
					_this.showListing(marker)
				}
			})
			marker.setLabel(label)
			// marker.addListener('mouseover', () => {
			// 	marker.setLabel(label)
			// })
			// marker.addListener('mouseout', () => {
			// 	marker.setLabel(null)
			// })
		})

		// Toggle menu (hidden / expanded)
		$('.map__container').find('.toggle').on('click', function(){
			$(this).toggleClass('is-active')
			$(this).closest('.map__container').find('.map__menu').toggleClass('is-hidden')
			$('#campus-map').toggleClass('is-expanded')
		})

		// On search input change
		this.cache.$mapSearchInput.on('keyup change', function(){
			let $self = $(this)
			_this.toggleIcons($self)
			// Run search
			_this.runSearch($self, map, locations, markers)
			// For mobile navigation, store positions and scroll to when clicked
			// if(!$('.map__categories').hasClass('is-active')){
			// 	$('.map__search ul').scrollLeft(0)
			// 	$('.map__search').find('li:visible').each(function(){
			//
			// 		let positionLeft = $(this).position().left
			// 		$(this).off('click').on('click', function(){
			// 			_this.slideToListing($(this), positionLeft)
			// 		})
			// 	})
			// }
		})

		// When listing is clicked
		$(document).on('click', '.map__search li', function(){
			let $currentItem = $(this)
			$(this).closest('ul').addClass('is-active')
			$('.map__categories').removeClass('is-active')
			$('#campus-map').removeClass('is-hidden')
			_this.toggleMarker($currentItem, map, locations, markers)
			$('.map__search').find('li').removeClass('is-active')
			$currentItem.addClass('is-active')
			$.each(markers, function(i, marker){
				if($currentItem.data('code') == marker.code){
					_this.focusLocation(map, marker, markers)
				}
			})
			_this.slideToListing($currentItem)
			_this.scrollToTop()
		})
	}

	scrollToTop(){
		let mapPositionTop = $('.map__container').position().top
		window.scroll({
		 top: mapPositionTop,
		 left: 0,
		 behavior: 'smooth'
		})
	}

	toggleIcons($self){
		if(!$self.val()){
			$self.closest('.map__search--input').find('button[name=search]').show()
			$self.closest('.map__search--input').find('button[name=clear]').hide()
		} else {
			$self.closest('.map__search--input').find('button[name=clear]').show()
			$self.closest('.map__search--input').find('button[name=search]').hide()
		}
	}

	showListing(marker){
		let img = ''
		if(marker.img.length != 0){
			img += '<img src=' + marker.img + ' alt=' + marker.name + '>'
		}
		$('.map__info').addClass('is-active')
		$('.map__info').empty()
		$('.map__info').append('<div><h6>'+marker.name+'</h6><a href="https://www.google.com/maps?saddr=My+Location&daddr='+marker.lat+','+marker.lng+'" class="link--cta">Get directions</a></div>'+img)
	}

	toggleMarker($currentItem, map, locations, markers){
		let _this = this
		$.each(markers, function(i, marker){
			if(marker.code == $currentItem.data('code')){
				marker.setVisible(true)
			}
		})
	}

	// Bring marker into focus
	focusLocation(map, marker, markers){
		let _this = this
    marker.setAnimation(4)
		$.each(markers, function(i, marker){
			marker.setIcon(_this.cache.icon)
		})
		marker.setIcon(_this.cache.iconFocus)
		let zoomLevel = 20
		map.setZoom(zoomLevel)
		map.setCenter(marker.getPosition())
	}

	// Bring corresponding listing into view when marker is selected
	scrollToListing(marker){
		if($('.map__search ul li.is-active').attr('data-code') != marker.code){
			$('.map__search ul').scrollTop(0)
			$('.map__search ul li').removeClass('is-active')
			$('.map__search ul li[data-code='+marker.code+']').addClass('is-active')
			// $('.map__search ul').scrollTop($('.map__search ul li[data-code='+marker.code+']').position().top)
			$('.map__search ul').animate({
				scrollTop: $('.map__search ul li[data-code='+marker.code+']').position().top
			}, 500)
		}
	}

	slideToListing($currentItem){
		let marginOffset = (window.innerWidth - $currentItem.innerWidth()) / 2
		let anchorLeft = $currentItem.position().left + 16
		let leftCoord = anchorLeft - marginOffset
		document.querySelector(`ul[data-type=listings]`).scrollBy({
			left: leftCoord,
			top: 0,
			behavior: 'smooth'
		})
	}

	// Regular search functionality is done through input.js
	runSearch($self, map, locations, markers){
		let value = $self.val().toLowerCase()
		// Allows users to search/filter by listing type
		this.cache.$mapSearch.find('ul li').not('li.no-results').each(function(){
			let listingType = $(this).attr('data-type').replace(/\-/g, ' ')
			let locationTitle = $(this).find('span').text().toLowerCase()
			if(listingType == value || listingType.indexOf(value) >= 0 || locationTitle.indexOf(value) >= 0){
				$(this).show()
			} else {
				$(this).hide()
			}
		})
		this.cache.$mapSearch.find('ul li').not(':hidden').last().css('margin-right', 0)
		if(this.cache.$mapSearch.find('ul li').not(':hidden').length === 1){
			this.cache.$mapSearch.find('ul li').css('width', '100%')
			this.cache.$mapSearch.find('ul span.pad-left-wrap--16').hide()
		} else {
			this.cache.$mapSearch.find('ul li').css('width', 'auto')
			this.cache.$mapSearch.find('ul span.pad-left-wrap--16').show()
		}

		// Handle the display of no results
		if(this.cache.$mapSearch.find('ul').children(':visible').not('li.no-results').length === 0){
			this.cache.$mapSearch.find('li.no-results').show()
		} else {
			this.cache.$mapSearch.find('li.no-results').hide()
		}
	}

	onSearchItemSelect($self, $currentItem){
		if(!$self.hasClass('is-active')){
			$self.addClass('is-active')
			$self.find('input[type=checkbox]').prop('checked', true)
		} else {
			$self.removeClass('is-active')
			$self.find('input[type=checkbox]').prop('checked', false)
		}
	}

	toggleMarkers($currentItem, $currentType, map, locations, type, markers, markerCluster){
		let _this = this
		this.cache.$mapInfo.removeClass('is-active')
		$.each(markers.markers_, function(i, marker){
			if(marker.secondarytype !== null && marker.secondarytype == 'interest'){
				marker.setVisible(false)
			}
			if(marker.primarytype == $currentType){
				marker.setVisible(true)
				_this.cache.bounds.extend(marker.position)
				map.fitBounds(_this.cache.bounds)
			}
		})
	}

	// Sets positions of interest as default markers
	setDefaultMarkers(map, markers){
		map.setZoom(15)
		map.setCenter(this.cache.mq)
		$.each(markers, function(i, marker){
			if(marker.secondarytype == 'interest'){
				markers[i].setVisible(true)
			}
		})
	}

	resetMenu(map, markers, markerCluster){
		this.cache.$mapInfo.removeClass('is-active')
		this.cache.$mapSearchInput.val('')
		$('.map__categories').removeClass('is-hidden')
		$('.map__categories').removeClass('is-active')
		$('.map__listings').removeClass('is-active')
		$('.map__listings').find('button').each(function(){
			if($(this).hasClass('is-visible')){
				$(this).removeClass('is-visible')
			}
		})
		$.each(markers, function(i, marker){
			markers[i].setVisible(false)
			markerCluster.repaint()
		})
		this.setDefaultMarkers(map, markers)
	}
}
